/** Development-only logging — silent in production builds. */
const isDev = import.meta.env.DEV;

export const devLog = {
  warn: (...args: unknown[]) => {
    if (isDev) {
      console.warn(...args);
    }
  },
  error: (...args: unknown[]) => {
    if (isDev) {
      console.error(...args);
    }
  },
};
